import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-priceList",
  "use": "icon-priceList-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-priceList\"><defs><style type=\"text/css\"></style></defs><path d=\"M979.2 889.6H108.8c-19.2 0-32-12.8-32-32V102.4c0-19.2-12.8-32-32-32s-32 12.8-32 32v787.2c0 32 25.6 64 64 64h896c19.2 0 32-12.8 32-32s-12.8-32-25.6-32zM172.8 640h64c6.4 0 19.2-6.4 25.6-19.2l64-108.8 96 217.6 19.2 19.2c12.8 6.4 32-6.4 38.4-19.2l128-422.4 89.6 307.2c0 12.8 12.8 25.6 32 25.6h160c12.8 19.2 32 32 51.2 32 32 0 64-25.6 64-64s-25.6-64-64-64c-25.6 0-44.8 12.8-51.2 32H748.8L633.6 185.6c0-12.8-19.2-25.6-38.4-19.2-6.4 0-12.8 6.4-12.8 6.4s-6.4 6.4-6.4 12.8L441.6 627.2l-83.2-192c0-6.4-6.4-6.4-6.4-12.8-6.4-6.4-19.2-6.4-32 0-6.4 0-12.8 6.4-12.8 12.8L217.6 576h-44.8c-19.2 0-32 12.8-32 32 0 12.8 12.8 32 32 32z\" p-id=\"2086\" fill=\"#d81e06\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/priceList.svg
// module id = DP5x
// module chunks = 118